import { Summary } from "types/Summary";
import { ActionType, getType } from "typesafe-actions";
import * as summaryActions from "./summaryActions";

export type SummaryState = {
  [K in summaryActions.SummaryContentType]?: {
    loading?: boolean;
    data?: Summary[];
    error?: string;
  };
};

export type SummaryActions = ActionType<typeof summaryActions>;

export default function summary(state: SummaryState = {}, action: SummaryActions) {
  switch (action.type) {
    case getType(summaryActions.load):
      return { ...state, [action.contentType]: { ...state[action.contentType], loading: true } };
    case getType(summaryActions.loadSuccess):
      return {
        ...state,
        [action.contentType]: { loading: false, data: action.data, error: undefined },
      };
    case getType(summaryActions.loadFail):
      return { ...state, [action.contentType]: { loading: false, error: action.error } };
    default:
      return state;
  }
}
